import {EntityModel} from "@fedeltapointofsale/data-client";
import {CustomObjectTypeData} from "./custom-object-type.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class CustomObjectTypeEntityModel extends EntityModel<CustomObjectTypeData> {
    constructor(injector: Injector) {
        super(injector, CustomObjectTypeData);
    }

    override getResourceName(): string {
        return "custom-object-type";
    }

    override getResource(): string {
        return "custom-group-type";
    }

    protected override onNewEntity(entityData: CustomObjectTypeData): void {
        entityData.searchable = true;
    }
}
